module.exports = __webpack_public_path__ + "img/bg.45db8f6e.png";